module.exports = __webpack_public_path__ + "static/s4-icons-46ec82f666a5f817d3e084c5f6546208.png";